export default __webpack_public_path__ + "static/discover-9a9b0b17d458b21b849de53348d76361.jpg";